import { AntTag } from '@agro-club/agroclub-shared'
import { User } from 'modules/domain/user/types'
import { getPersonalNumberLabel } from 'modules/utils/numbers/formatPersonalNumber'
import { FC, Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CompanyCommercialTag } from 'views/pages/Company/CompanyCommercialTag'
import APhone from 'views/ui/Phone/APhone'
import { CompanySizeTag } from './CompanySizeTag'
import { CompaniesInfo } from './CompaniesInfo'
import styled from 'styled-components'
import { CompanyGroupedContacts } from './CompanyGroupContacts'

type Props = {
  user: User
}
export const UserProfileTag = ({ user }: Props) => {
  const { t } = useTranslation('user')
  const profile = user.profile
  return (
    <AntTag color="white">{profile?.profile_type ? t(`profile_type.${profile.profile_type}`) : t('no_profile')}</AntTag>
  )
}

const FirstLineContainer = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  gap: 0 10px;
`

export const HeaderSubTitleValue: FC<Props> = ({ user }) => {
  const profile = user.profile
  const company = user.profile?.company
  const [hasRelatedCompanies, setHasRelatedCompanies] = useState(false)

  const displayParts = [
    company?.inn && <span>{`${getPersonalNumberLabel()}: ${company.inn}`}</span>,
    user.email && <span>{user.email}</span>,
  ].filter(Boolean)

  return (
    <div>
      <FirstLineContainer>
        <CompanyCommercialTag commercial={user.profile?.company?.commercial} />
        <CompanySizeTag companySize={profile?.company_size} />
        <UserProfileTag user={user} />
        {company && (
          <CompaniesInfo company={company} onLoaded={(hasConnected) => setHasRelatedCompanies(hasConnected)} />
        )}
      </FirstLineContainer>
      <div style={{ display: 'flex', gap: 10 }}>
        {!!displayParts.length && (
          <div>
            {displayParts.map((part, index) => (
              <Fragment key={index}>
                {index > 0 && ' / '}
                {part}
              </Fragment>
            ))}
          </div>
        )}
        {user.phone && !hasRelatedCompanies && <APhone phone={user.phone} isMobile={user.is_mobile_phone} />}
        {company && hasRelatedCompanies && <CompanyGroupedContacts company={company} phone={user.phone} />}
      </div>
    </div>
  )
}
